module.exports = __webpack_public_path__ + "img/bump.2a7a1ddd.svg";